import React, { Component } from 'react';
import JurisHeader from './components/JurisHeader';
import JurisServices from './components/JurisServices';
import JurisContact from './components/JurisContact';
import JurisFooter from './components/JurisFooter';
import GoogleMap from './components/GoogleMap';
import EmailForm from './components/EmailForm';

import { Provider } from 'react-redux';
import store from './redux/store';

class Juris extends Component {
  render() {
    return (
        <Provider store={store}>
            <div className="juris">
                <div className="main-container">
                    <div className="container-fluid">
            
                        <JurisHeader />

                        <JurisServices />

                        <div className="row reveal-background"></div>

                        <div className="row">

                            <div className="col-xs-12">
                                <JurisContact />
                            </div>

                            <div className="juris-contact-body light-bg col-xs-12">

                                <div className="row">
                                    <div className="container">

                                        <div className="row">

                                            <div className="col-xs-12 col-md-6">
                                                <EmailForm />
                                            </div>

                                            <div className="col-xs-12 col-md-6 ">
                                                <GoogleMap initialCenter={{ lat: 45.4670565, lng: -73.6389082 }}  />
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>

                        <JurisFooter />

                    </div>
                </div>
            </div>
        </Provider>
    );
  }
}

export default Juris;



/** WEBPACK FOOTER **
 ** ./src/Juris.js
 **/